import {TranslatedKeys} from 'shared/types/translated-keys';

export interface ProductReportProps {
  id: string;
  name: string;
  total: number;
  quantity: number;
  createdAt: string;
}

export const translatedProductReportProps: TranslatedKeys<ProductReportProps> =
  {
    name: 'Produto',
    quantity: 'Quantidade vendida',
    total: 'Total vendido',
    createdAt: 'Data',
  };

export interface UsersReportProps {
  id: string;
  name: string;
  phone: string;
  email: string;
  total: number;
  quantity: number;
  deliveries: number;
}

export const translatedUsersReportProps: TranslatedKeys<UsersReportProps> = {
  name: 'Cliente',
  email: 'Email',
  phone: 'Telefone',
  quantity: 'Quantidade de pedidos',
  total: 'Total sem entregas',
  deliveries: 'Total com entregas',
};

export interface AdditionalReportProps {
  id: string;
  name: string;
  total: number;
  quantity: number;
}

export const translatedAdditionalReportProps: TranslatedKeys<AdditionalReportProps> =
  {
    name: 'Adicional',
    quantity: 'Quantidade vendida',
    total: 'Total vendido',
  };
